function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Home_security"
}, /*#__PURE__*/React.createElement("title", null, "190902_VF_Product_NL_Icons"), /*#__PURE__*/React.createElement("path", {
  d: "M255.6 255.1V119.7l14.7 7.7 13.2-25-141.8-74.1L0 102.4l13.2 25 14.7-7.7v135.4h227.7zm-28.4-28.2H56.4v-122l85.3-44.6 85.3 44.6.2 122z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.2 141.8v-19.3c0-12.8-10.3-23.2-23.1-23.2h-24.7c-12.8 0-23.1 10.4-23.1 23.2v19.3H92.2v70.9h99.1v-70.9h-14.1zm-56.4-19.3c0-4.8 3.8-8.7 8.6-8.7h24.7c4.8 0 8.6 3.9 8.6 8.7v19.1h-42v-19.1zm56 75.7h-70.1v-41.9h70.1v41.9z"
}))));